import { createContext } from "react";
import { UserContextInterface } from "./types";
export const UserContext = createContext(
  {} as {
    user: UserContextInterface;
    setUser: React.Dispatch<React.SetStateAction<UserContextInterface>>;
  }
);
